<script setup lang="ts">
  defineOptions({ name: 'BetaPreviewBanner' })

  import CPText from '@ui/components/CPText.vue'

  import { createElementId } from '@common/core-layer/utils'

  import { useBetaPreview } from '../composables/useBetaPreview'

  defineProps({
    message: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'sm',
    },
    weight: {
      type: String,
      default: 'medium',
    },
  })

  const betaPreviewBannerRootId = createElementId('beta', 'preview', 'banner')

  const { isShowBetaPreviewEnabled } = useBetaPreview()
</script>

<template>
  <div
    v-if="isShowBetaPreviewEnabled"
    :id="betaPreviewBannerRootId"
    class="flex min-h-10 w-full shrink-0 items-center justify-center bg-primary px-4 py-2 shadow-sm"
    :class="classes || undefined"
    role="status"
    aria-live="polite"
  >
    <CPText :size="size" :weight="weight" class="text-on-primary">
      {{ message }}
    </CPText>
  </div>
</template>
